import React, { FunctionComponent, PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';
import { Main, Spinner } from '@vwfs-bronson/bronson-react';
import { Page } from '..';
import { loadingSelectors } from '../services/redux/features/loading.slice';
import { Footer } from './Layout/Footer';
import { Header } from './Layout/Header';

export type DefaultLayoutProps = {
  pages: { hybridJourney: Page[]; dealerJourney: Page[] };
};

export const BaseWrapper: FunctionComponent<PropsWithChildren<DefaultLayoutProps>> = ({ children, pages }) => {
  const globalLoading = useSelector(loadingSelectors.selectLoading);
  const isRenderingLocalSpinner = useSelector(loadingSelectors.selectIsRenderingLocalSpinner);
  const isContextualLoading = useSelector(loadingSelectors.selectIsContextualLoading);
  const renderSpinner = !isRenderingLocalSpinner && (globalLoading || isContextualLoading);

  return (
    <>
      <Header />
      {renderSpinner ? <Spinner center fullPage /> : null}
      <Main>{children}</Main>
      <Footer pages={pages} />
    </>
  );
};
